const Role = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
  AUDITOR: "auditor",
  CONSENT_MANAGER: "consent_manager",
  DATA_PRIVACY_OFFICER: "data_privacy_officer",
  PEOPLE_OPERATIONS: "people_operations_person",
  COMPLIANCE_PROGRAM_MANAGER: "compliance_program_manager",
  INFORMATION_SECURITY_OFFICER: "information_security_officer",
};

export default Role;
